import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createImageMockSource } from '@/mocks/create-image-mock-source';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftTicketDetailResponse } from '@/repositories/generated';

const ticketMap: Record<string, GiftTicketDetailResponse> = {
  '0055': {
    giftTicketId: '0055',
    giftTicketName: '青券（中小・一般店のみで利用可）',
    giftBusinessId: '001',
    giftTicketImagePath: createImageMockSource('青券', { width: 750, height: 220 }),
    giftTicketDescription: 'あ'.repeat(2000),
    createdAt: '2025-05-12T17:41:00+09:00',
    updatedAt: '2025-05-12T17:41:00+09:00',
    usingSalesManagementsCount: 2,
    usingSalesManagements: [
      { giftSalesManagementId: '0018', giftSalesManagementName: '青森市商品券（第1期）' },
      { giftSalesManagementId: '0022', giftSalesManagementName: '青森市商品券（第2期）' },
    ],
    customField1: 'い'.repeat(2000),
    customField2: 'う'.repeat(2000),
    customField3: 'え'.repeat(2000),
    customField4: 'お'.repeat(2000),
    customField5: 'か'.repeat(2000),
  },
  '0777': {
    giftTicketId: '0777',
    giftTicketName: '赤券（大型店・一般店で利用可能）',
    giftBusinessId: '001',
    giftTicketImagePath: createImageMockSource('赤券', {
      width: 750,
      height: 220,
      backgroundColor: '#ff6347',
      textColor: '#ffffff',
    }),
    giftTicketDescription: '大型店・一般店で利用可能な商品券です。',
    createdAt: '2025-05-12T17:41:00+09:00',
    updatedAt: '2025-05-12T17:41:00+09:00',
    usingSalesManagementsCount: 1,
    usingSalesManagements: [
      { giftSalesManagementId: '0018', giftSalesManagementName: '青森市商品券（第1期）' },
    ],
  },
  '0088': {
    giftTicketId: '0088',
    giftTicketName: '緑券（一般店で利用可能）',
    giftBusinessId: '001',
    giftTicketImagePath: createImageMockSource('緑券', { width: 750, height: 220 }),
    giftTicketDescription: '一般店で利用可能な商品券です。',
    createdAt: '2025-05-12T17:41:00+09:00',
    updatedAt: '2025-05-12T17:41:00+09:00',
    usingSalesManagementsCount: 0,
    usingSalesManagements: [],
  },
};

export const giftTicketDetail = http.get(
  createMockEndpoint('/gift_ticket/:id'),
  async ({ params }) => {
    await delay(500);
    const id = params.id as string;
    const data = ticketMap[id];
    if (!data) {
      return HttpResponse.json({ message: 'Not Found' }, { status: 404 });
    }
    return HttpResponse.json(data, { status: 200 });
  },
);
